module.exports = __webpack_public_path__ + "static/media/tlyfe.4b8d6881.svg";